<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>

    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jkjy">健康教育</router-link> >
      <router-link :to="currentPath">{{ channelName }}</router-link> >
      {{ current.title }}
    </div>

    <div class="container-width">
      <ARTICLE
        :current="current"
        :before="before"
        :after="after"
        :showBeforeAfter="showBeforeAfter"
        :showorigin="showorigin"
        @changePage="handleChangePage"
      ></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../service/jkjy";
import BANNER from "../../components/banner/jkjy";
export default {
  name: "JKJYARTICLE",
  data() {
    return {
      navigationData: [
        {
          name: "内科",
          path: "/jkjy",
          width: "20%",
        },
        {
          name: "外科",
          path: "/jkjy/waike",
          width: "20%",
        },
        {
          name: "妇产科",
          path: "/jkjy/fuchanke",
          width: "20%",
        },
        {
          name: "儿科",
          path: "/jkjy/erke",
          width: "20%",
        },
        {
          name: "感染科",
          path: "/jkjy/ganranke",
          width: "20%",
        },
        {
          name: "中医科",
          path: "/jkjy/zhongyike",
          width: "20%",
        },
        {
          name: "五官科",
          path: "/jkjy/wuguanke",
          width: "20%",
        },
        {
          name: "心理科",
          path: "/jkjy/xinlike",
          width: "20%",
        },
        {
          name: "医辅科室",
          path: "/jkjy/yifu",
          width: "20%",
        },
        {
          name: "其他科室",
          path: "/jkjy/qita",
          width: "20%",
        },
      ],
      currentPath: "",
      current: {
        title: "",
        description: "",
        releaseDate: "",
        views: "",
        origin: "",
      },
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: true, //是否显示上一篇 下一篇
      showorigin: true, //是否显示来源 发布时间 点击次数
      channelList: [],
      channelName: "",
      channel: {}, //当前栏目 相关信息
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.getLeftChannel();
    let currentpathData = {};
    currentpathData = this.navigationData.filter((item) => {
      return item.name == this.$route.query.channelName;
    });
    this.currentPath = currentpathData[0].path;
  },
  beforeMount() {},
  methods: {
    // 左侧栏目
    getLeftChannel() {
      this.channelName = this.$route.query.channelName; // 栏目名
      service.getChannelList(
        {
          isshow: "1",
        },
        (res) => {
          res.content.map((item) => {
            if (item.name == this.channelName) {
              this.channel = { ...item };
            }
          });

          this.channelList = res.content || [];
          this.init();
        }
      );
    },
    // 获取文章内容
    init() {
      let id = this.$route.query.id; // 文章id
      let parmes = {
        id: id,
        channelId: this.channel.id,
      };

      service.getChannelInfo(parmes, (res) => {
        res.current.releaseDate = res.current.releaseDate
          ? res.current.releaseDate.split(" ")[0]
          : "";
        res.current.description = res.current.description.replace(
          /<table[^>]*>/gi,
          function (match, capture) {
            return match.replace(/width=\"(.*)\"/gi, "style='width:90%'");
          }
        );
        this.current = { ...res.current };
        if (res.before) {
          this.before = { ...res.before };
          this.before.active = true;
        } else {
          this.before.title = "已经没有上一篇";
          this.before.active = false;
        }
        if (res.after) {
          this.after = { ...res.after };
          this.after.active = true;
        } else {
          this.after.title = "已经没有下一篇";
          this.after.active = false;
        }
      });
    },
    // 上一篇 下一篇
    handleChangePage(id) {
      const query = JSON.parse(JSON.stringify(this.$route.query)); // 获取路由参数信息
      query.id = id; //改变参数
      this.$router.push({ path: this.$route.path, query }); //更新路由
      this.init(id);
    },
    changeChanel(e) {
      this.channel = { ...e };
      this.$router.push({
        path: `/jkjy`,
        query: {
          channelName: e.name,
          channelId: e.id,
        },
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>
